import {
  Breadcrumb,
  message,
  Card,
  Row,
  Col,
  Descriptions,
  Avatar,
  Spin,
  Typography,
  Divider,
  Space,
  Button,
  Collapse,
  QRCode,
  Modal,
  Statistic,
  Image,
  Popconfirm,
  Tooltip,
} from "antd";
import { NavLink, useParams, Link } from "react-router-dom";
import {
  UserOutlined,
  PhoneOutlined,
  MailOutlined,
  HomeOutlined,
  CalendarOutlined,
  ShopOutlined,
  ArrowLeftOutlined,
  CaretRightOutlined,
  MessageOutlined,
  QrcodeOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  PictureOutlined,
  StarOutlined,
  BranchesOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import axios from "axios";
import { settings } from "../../../utils/config";
import { useEffect, useState } from "react";
// import ButtonWithPermission from "../../../components/ButtonWithPermission/ButtonWithPermission";
import PointHistoryCustomer from "./Info/PointHistoryCustomer";
import { pointPromotionAPIWithErrorHandling } from "../../../api/pointPromotion/pointPromotionApi";
import { customerApiWithErrorHandling } from "../../../api/customer/customerApi";
import hasPermission from "../../../components/PermissionHocs/hasPermission";
import { ACCOUNT_STATE_MAP, deriveAccountState } from "./customerConstants";
import { resolveImageUrl } from "../../../utils/image";
import { brand, semantic, neutral } from "../../../theme/tokens";
import StatusTag from "../../../components/cms/StatusTag";

const { Text } = Typography;

const CUSTOMER_TYPE_MAP = {
  MANUAL: { label: "Mặc định", color: "default" },
  CONTRACTOR: { label: "Thợ thầu", color: "green" },
  DEALER: { label: "Đại lý", color: "blue" },
  NPP: { label: "Nhà phân phối", color: "purple" },
};

export default function CustomerDetail() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [infomation, setInfo] = useState(null);
  const [branches, setBranches] = useState([]);
  const [branchLoading, setBranchLoading] = useState(false);
  // const [dataVoices, setDataVoices] = useState([]);
  // const [loadingVoice, setLoadingVoice] = useState(true);
  const [paginationVoice, setPaginationVoice] = useState({ current: 1, pageSize: 10, total: 0 });

  const [dataHistories, setDataHistories] = useState([]);
  const [loadingHistories, setLoadingHistories] = useState(true);
  const [paginationHistories, setPaginationHistories] = useState({ current: 1, pageSize: 10, total: 0 });
    
  const [approving, setApproving] = useState(false);
  const [customerImages, setCustomerImages] = useState([]);
  // const { callNow } = useSip();

  // API call function for customer info
  const fetchInfo = async (id) => {
    try {
      setLoading(true);

      const baseUrl = process.env.REACT_APP_API_URL;
      const exportUrl = new URL(
        `${baseUrl}/mcoupon/api/v1/customer/getId/${id}`
      );

      const hasAccessToken = settings?.getCookie("access_token");
      const response = await axios.get(exportUrl.toString(), {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${hasAccessToken}`,
        },
      });

      const result = response.data;

      if (result.message && result.data) {
        setInfo(result.data);
        message.success("Tải dữ liệu thành công!");
      } else {
        setInfo(null);
        message.warning("Không có thông tin!");
      }
    } catch (error) {
      console.error("Error fetching infomation:", error);

      if (error.response) {
        const status = error.response.status;
        const errorMessage =
          error.response.data?.message || "Lỗi không xác định";

        if (status === 401) {
          message.error("Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại!");
        } else if (status === 403) {
          message.error("Bạn không có quyền truy cập chức năng này!");
        } else if (status === 404) {
          message.error("Không tìm thấy dữ liệu!");
        } else {
          message.error(`Lỗi ${status}: ${errorMessage}`);
        }
      } else if (error.request) {
        message.error(
          "Không thể kết nối tới server. Vui lòng kiểm tra kết nối mạng!"
        );
      } else {
        message.error("Không thể tải. Vui lòng thử lại!");
      }

      setInfo(null);
    } finally {
      setLoading(false);
    }
  };

  // API call function for branches
  const fetchBranch = async (id) => {
    try {
      setBranchLoading(true);

      const baseUrl = process.env.REACT_APP_API_URL;
      const exportUrl = new URL(
        `${baseUrl}/mcoupon/api/v1/customers/get-branchs-by-user/${id}`
      );

      const hasAccessToken = settings?.getCookie("access_token");
      const response = await axios.get(exportUrl.toString(), {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${hasAccessToken}`,
        },
      });

      const result = response.data;

      if (result.data) {
        setBranches(result.data);
      } else {
        setBranches([]);
      }
    } catch (error) {
      console.error("Error fetching branch:", error);

      if (error.response) {
        const status = error.response.status;
        const errorMessage =
          error.response.data?.message || "Lỗi không xác định";

        if (status === 401) {
          message.error("Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại!");
        } else if (status === 403) {
          message.error("Bạn không có quyền truy cập chức năng này!");
        } else if (status === 404) {
          message.error("Không tìm thấy dữ liệu chi nhánh!");
        } else {
          message.error(`Lỗi ${status}: ${errorMessage}`);
        }
      } else if (error.request) {
        message.error(
          "Không thể kết nối tới server. Vui lòng kiểm tra kết nối mạng!"
        );
      } else {
        message.error("Không thể tải dữ liệu chi nhánh. Vui lòng thử lại!");
      }

      setBranches([]);
    } finally {
      setBranchLoading(false);
    }
  };

  

  // // Load voice history
  // const loadDataVoiceHis = async (params = {}) => {
  //   try {
  //     setLoadingVoice(true);
  //     const response = await voiceIpAPIWithErrorHandling.getHistories({
  //       page: paginationVoice.current,
  //       per_page: paginationVoice.pageSize,
  //       phone: infomation.phone,
  //       ...params,
  //     });

  //     if (response.success) {
  //       const { data: responseDataVoice } = response;
  //       setDataVoices(responseDataVoice.data);
  //       setPaginationVoice({
  //         ...paginationVoice,
  //         pageSize: responseDataVoice.per_page,
  //         current: responseDataVoice.current_page,
  //         total: responseDataVoice.total,
  //       });
  //     }
  //   } catch (error) {
  //     message.error(error.message);
  //   } finally {
  //     setLoadingVoice(false);
  //   }
  // };

  const loadDataPointHis = async (params = {}) => {
    try {
      setLoadingHistories(true);
      // Lịch sử điểm TỔNG HỢP: tất cả loại biến động điểm của khách (mọi trạng thái)
      const response = await pointPromotionAPIWithErrorHandling.getPointHistoriesByCustomerId(id, {
        page: paginationVoice.current,
        size: paginationVoice.pageSize,
        ...params,
      });

      const body = response.data; // { success, message, data: <paginator> }

      if (body?.success) {
        const paginator = body.data || {};
        setDataHistories(paginator.data || []);

        setPaginationHistories({
          ...paginationVoice,
          pageSize: paginator.per_page || paginationVoice.pageSize,
          current: paginator.current_page || 1,
          total: paginator.total || 0,
        });
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoadingHistories(false);
    }
  };

  
  const handleTableVoiceChange = (newPagination) => {
    setPaginationVoice(newPagination);
    loadDataPointHis({
      page: newPagination.current,
      size: newPagination.pageSize,
    });
  };

  const fetchCustomerImages = async (customerId) => {
    try {
      const res = await customerApiWithErrorHandling.getImages(customerId);
      if (res?.data) {
        setCustomerImages(res.data);
      }
    } catch (error) {
      // silent — images are optional
    }
  };

  useEffect(() => {
    fetchInfo(id);
    fetchBranch(id);
    fetchCustomerImages(id);
  }, [id]);

  useEffect(() => {
    if (infomation) {
      loadDataPointHis();
      // loadDataVoiceHis();
    }
  }, [infomation]);

  // Build tree structure for branches (similar to StoreList)
  const buildTree = (branches) => {
    const branchMap = new Map();

    // Initialize children array for each branch
    branches.forEach((branch) => {
      branch.children = [];
      branchMap.set(branch.id, branch);
    });

    // Build tree structure
    const rootBranches = [];
    branches.forEach((branch) => {
      if (branch.parent_id) {
        const parent = branchMap.get(branch.parent_id);
        if (parent) {
          parent.children.push(branch);
        }
      } else {
        rootBranches.push(branch);
      }
    });

    return rootBranches;
  };

  // Get address string from address object
  const getAddress = (address) => {
    const { province, ward } = address || {};
    const parts = [province?.name, ward?.name].filter(Boolean);
    return parts.length ? parts.join(" - ") : "Chưa cập nhật";
  };

  // Get membership rank
  const getRank = (branch) => {
    if (!branch || !branch.membership_class) return "Chưa có hạng";
    return branch.membership_class.name;
  };

  // Format phone number
  const formatPhoneNumber = (phone) => {
    if (!phone) return "Chưa cập nhật";
    return phone.replace(/^84/, "0");
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "Chưa cập nhật";
    return dayjs(dateString).format("DD/MM/YYYY");
  };

  // Calculate age
  const calculateAge = (birthday) => {
    if (!birthday) return null;
    const age = dayjs().diff(dayjs(birthday), "year");
    return age;
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "50px" }}>
        <Spin size="large" />
        <div style={{ marginTop: 16 }}>Đang tải thông tin khách hàng...</div>
      </div>
    );
  }

  if (!infomation) {
    return (
      <div style={{ textAlign: "center", padding: "50px" }}>
        <Text type="secondary">Không tìm thấy thông tin khách hàng</Text>
      </div>
    );
  }

  const treeBranches = buildTree(branches);

  /*
   * Dùng chung `deriveAccountState` + `ACCOUNT_STATE_MAP` với màn danh sách thay vì
   * chép lại logic ở đây. Bản chép tay cũ có hai lỗi: mặc định `!user` thành
   * "active" (khách chưa có tài khoản mà hiện "Hoạt động"), và bảng nhãn khai key
   * `color` trong khi nơi render đọc `stateTag.tone` — luôn undefined nên mọi trạng
   * thái ở màn này đều rơi về tone xám.
   */
  const accountState = deriveAccountState(infomation?.user);
  const isPending = accountState === "pending" || accountState === "rejected";
  const isLocked = accountState === "locked";
  // `unknown` = không có tài khoản đăng nhập: không có gì để duyệt hay để khóa.
  const hasAccount = accountState !== "unknown";
  const stateTag = ACCOUNT_STATE_MAP[accountState] || ACCOUNT_STATE_MAP.unknown;

  const totalPoints = branches.reduce((sum, b) => sum + (b.point || 0), 0);

  const customerTypeInfo = CUSTOMER_TYPE_MAP[infomation.customer_type] || CUSTOMER_TYPE_MAP.MANUAL;

  const runAction = async (fn) => {
    try {
      setApproving(true);
      const res = await fn();
      message.success(res.message || "Thao tác thành công");
      fetchInfo(id);
    } catch (error) {
      message.error(error.message || "Thao tác thất bại");
    } finally {
      setApproving(false);
    }
  };

  const handleApprove = () => runAction(() => customerApiWithErrorHandling.approve(infomation.id, "approve"));
  const handleReject = () => runAction(() => customerApiWithErrorHandling.approve(infomation.id, "reject", null));
  const handleToggleLock = () => runAction(() => customerApiWithErrorHandling.toggleLock(infomation.id));

  // Duyệt/từ chối/khóa dùng chung quyền với sửa khách hàng — khớp middleware
  // `check.permission:mcoupon.customer.update` của hai route BE. Nút bị khóa thật
  // (không chỉ ẩn) nên `Popconfirm` cũng không bung ra.
  const canManageAccount = hasPermission({ actions: ["mcoupon.customer.update"] });
  // Tooltip rỗng thì antd không render gì — chỉ hiện lý do khi đúng là thiếu quyền.
  const noPermissionTip = canManageAccount ? "" : "Bạn không có quyền thực hiện thao tác này";

  // const handleCall = async () => {
  //   let phoneNumber = infomation.phone;
  //   if (!phoneNumber) {
  //     message.warning("Số điện thoại không hợp lệ");
  //     return;
  //   }

  //   // Chuẩn hóa số điện thoại
  //   phoneNumber = phoneNumber.trim();
  //   if (phoneNumber.startsWith("84")) {
  //     phoneNumber = "0" + phoneNumber.slice(2);
  //   }

  //   // Kiểm tra lại định dạng cuối cùng
  //   if (!/^0\d{9,10}$/.test(phoneNumber)) {
  //     message.warning("Số điện thoại không hợp lệ");
  //     return;
  //   }

  //   callNow(phoneNumber);
  // };

  return (
    <div
      style={{
        padding: "24px",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      {/* Breadcrumb */}
      <div style={{ marginBottom: "24px" }}>
        <Breadcrumb separator=">">
          <Breadcrumb.Item>
            <NavLink to="/">Trang chủ</NavLink>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <NavLink to="/customer">Khách hàng</NavLink>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Chi tiết khách hàng</Breadcrumb.Item>
        </Breadcrumb>
      </div>

      {/* Header */}
      {/* <Card style={{ marginBottom: "24px" }}>
        <Row align="middle" justify="space-between">
          <Col>
            <Space size="large">
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <Avatar
                  size={64}
                  icon={<UserOutlined />}
                  src={resolveImageUrl(infomation.avatar)}
                  style={{ backgroundColor: brand.accent }}
                />
                <div>
                  <Title level={3} style={{ margin: 0 }}>
                    {infomation.name || "Chưa cập nhật tên"}
                  </Title>
                </div>
              </div>
            </Space>
          </Col>
          <Col>
            <Button
              icon={<ArrowLeftOutlined />}
              onClick={() => window.history.back()}
            >
              Quay lại
            </Button>
          </Col>
        </Row>
      </Card> */}

      {/* Mini Dashboard */}
      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        <Col xs={12} sm={6}>
          <Card>
            <Statistic
              title="Vai trò khách hàng"
              valueRender={() => (
                <StatusTag style={{ fontSize: 14 }}>{customerTypeInfo.label}</StatusTag>
              )}
            />
          </Card>
        </Col>
        <Col xs={12} sm={6}>
          <Card>
            <Statistic
              title="Trạng thái"
              valueRender={() => (
                <StatusTag tone={stateTag.tone} dot style={{ fontSize: 14 }}>
                  {stateTag.label}
                </StatusTag>
              )}
            />
          </Card>
        </Col>
        <Col xs={12} sm={6}>
          <Card>
            <Statistic
              title="Tổng điểm"
              value={totalPoints}
              prefix={<StarOutlined />}
              valueStyle={{ color: brand.accent }}
            />
          </Card>
        </Col>
        <Col xs={12} sm={6}>
          <Card>
            <Statistic
              title="Chi nhánh"
              value={branches.length}
              prefix={<BranchesOutlined />}
              valueStyle={{ color: semantic.success }}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[24, 24]}>
        {/* Thông tin cá nhân */}
        <Col xs={24} md={24} lg={18}>
          <Card title="Thông tin cá nhân" style={{ height: "100%" }}>
            <Descriptions column={1} bordered labelStyle={{ fontWeight: "bold" }}>
              <Descriptions.Item
                label={
                  <div className="">
                    <UserOutlined /> Họ tên
                  </div>
                }
              >
                {infomation.name || "Chưa cập nhật"}
              </Descriptions.Item>

              <Descriptions.Item
                label={
                  <div className="">
                    <CalendarOutlined /> Ngày sinh
                  </div>
                }
              >
                {formatDate(infomation.birthday)}
              </Descriptions.Item>

              <Descriptions.Item
                label={
                  <div className="">
                    <PhoneOutlined /> Số điện thoại
                  </div>
                }
              >
                <Text copyable>{formatPhoneNumber(infomation.phone)}</Text>
              </Descriptions.Item>

              <Descriptions.Item
                label={
                  <div className="">
                    <MailOutlined /> Email
                  </div>
                }
              >
                <Text copyable>{infomation.email || "Chưa cập nhật"}</Text>
              </Descriptions.Item>

              <Descriptions.Item
                label={
                  <div className="">
                    <HomeOutlined /> Địa chỉ
                  </div>
                }
              >
                {infomation.address_info || "Chưa cập nhật"}
              </Descriptions.Item>

              <Descriptions.Item
                label={
                  <div className="">
                    <CalendarOutlined /> Ngày tạo
                  </div>
                }
              >
                {formatDate(infomation.created_at)}
              </Descriptions.Item>

              <Descriptions.Item
                label={
                  <div className="">
                    <ShopOutlined /> Vai trò khách hàng
                  </div>
                }
              >
                <StatusTag>{customerTypeInfo.label}</StatusTag>
              </Descriptions.Item>

            </Descriptions>

            {/* Customer Images */}
            {customerImages.length > 0 && (
              <>
                <Divider orientation="left">
                  <PictureOutlined /> Hình ảnh đơn vị
                </Divider>
                <Image.PreviewGroup>
                  <Space wrap size={12}>
                    {customerImages.map((img) => (
                      <Image
                        key={img.id}
                        width={120}
                        height={120}
                        src={resolveImageUrl(img.image_url)}
                        style={{ objectFit: "cover", borderRadius: 8 }}
                        placeholder={
                          <div style={{ width: 120, height: 120, display: "flex", alignItems: "center", justifyContent: "center", background: neutral[100] }}>
                            <PictureOutlined style={{ fontSize: 24, color: neutral[400] }} />
                          </div>
                        }
                      />
                    ))}
                  </Space>
                </Image.PreviewGroup>
              </>
            )}
          </Card>
        </Col>

        
        <Col xs={24} md={24} lg={6}>
          <Card title="Thao tác">
            <Space
              direction="vertical"
              size="middle"
              style={{ width: "100%" }}
            >
              {/* Ảnh đơn vị để đối chiếu khi xét duyệt đại lý đang chờ */}
              {accountState === "pending" && infomation.customer_type === "DEALER" && (
                <div style={{ width: "100%" }}>
                  <Text strong style={{ fontSize: 13, display: "block", marginBottom: 8 }}>
                    <PictureOutlined /> Ảnh đơn vị (xét duyệt)
                  </Text>
                  {customerImages.length > 0 ? (
                    <Image.PreviewGroup>
                      <Space wrap size={8}>
                        {customerImages.map((img) => (
                          <Image
                            key={img.id}
                            width={72}
                            height={72}
                            src={resolveImageUrl(img.image_url)}
                            style={{ objectFit: "cover", borderRadius: 6 }}
                          />
                        ))}
                      </Space>
                    </Image.PreviewGroup>
                  ) : (
                    <div
                      style={{
                        padding: "10px 12px",
                        background: semantic.dangerSubtle,
                        border: "1px solid #FECACA",
                        borderRadius: 8,
                        color: semantic.danger,
                        fontSize: 12,
                      }}
                    >
                      Chưa có hình ảnh đơn vị để đối chiếu.
                    </div>
                  )}
                  <Divider style={{ margin: "12px 0" }} />
                </div>
              )}

              {/* span bọc ngoài: nút đang disabled không phát sự kiện chuột nên
                  Tooltip neo thẳng vào nút sẽ không bao giờ hiện — đúng lúc cần
                  nói lý do nhất. Cùng bẫy đã ghi ở `RowActions`. */}
              <Tooltip title={noPermissionTip}>
                <span style={{ display: "block" }}>
              {!hasAccount ? (
                <div style={{ fontSize: 13, color: neutral[500], textAlign: "center" }}>
                  Khách hàng chưa có tài khoản đăng nhập.
                </div>
              ) : isPending ? (
                /* Cột thao tác chỉ rộng 1/4 màn ở lg (còn ~180px trong Card) nên hai nút
                   nằm ngang là tràn. Cho xuống dòng + flex-basis: hẹp thì mỗi nút chiếm
                   trọn một hàng, rộng thì vẫn đứng cạnh nhau. */
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                  <Popconfirm
                    title="Duyệt tài khoản này?"
                    onConfirm={handleApprove}
                    okText="Duyệt"
                    cancelText="Hủy"
                  >
                    <Button
                      type="primary"
                      icon={<CheckCircleOutlined />}
                      loading={approving}
                      disabled={!canManageAccount}
                      style={{
                        flex: "1 1 160px",
                        height: 40,
                        fontWeight: 600,
                        backgroundColor: semantic.success,
                        borderColor: semantic.success,
                      }}
                    >
                      Duyệt tài khoản
                    </Button>
                  </Popconfirm>
                  {accountState === "pending" && (
                    <Popconfirm
                      title="Từ chối tài khoản này?"
                      onConfirm={handleReject}
                      okText="Từ chối"
                      okButtonProps={{ danger: true }}
                      cancelText="Hủy"
                    >
                      <Button
                        danger
                        icon={<CloseCircleOutlined />}
                        loading={approving}
                        disabled={!canManageAccount}
                        style={{ flex: "1 1 110px", height: 40, fontWeight: 600 }}
                      >
                        Từ chối
                      </Button>
                    </Popconfirm>
                  )}
                </div>
              ) : (
                <Popconfirm
                  title={isLocked ? "Mở khóa tài khoản này?" : "Khóa tài khoản này?"}
                  onConfirm={handleToggleLock}
                  okText={isLocked ? "Mở khóa" : "Khóa"}
                  okButtonProps={isLocked ? {} : { danger: true }}
                  cancelText="Hủy"
                >
                  <Button
                    type="primary"
                    danger={!isLocked}
                    icon={isLocked ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                    loading={approving}
                    disabled={!canManageAccount}
                    style={{
                      width: "100%",
                      height: 40,
                      fontWeight: 600,
                      ...(isLocked ? { backgroundColor: semantic.success, borderColor: semantic.success } : {}),
                    }}
                  >
                    {isLocked ? "Mở khóa tài khoản" : "Khóa tài khoản"}
                  </Button>
                </Popconfirm>
              )}
                </span>
              </Tooltip>

              {/* <Button
                type="primary"
                icon={<PhoneOutlined />}
                onClick={handleCall}
                style={{ width: "100%", height: 40, backgroundColor: semantic.success }}
              >
                Liên hệ
              </Button> */}
              
              <Button
                size="middle"
                icon={<MessageOutlined />}
                href={`https://zalo.me/${infomation.phone}`}
                target="_blank"
                style={{ 
                  width: '100%',
                  height: 40,
                  background: "#0d2d96",
                  border: '2px solid white',
                  color: 'white',
                }}
              >
                Chat Zalo
              </Button>
              
              <Button
                size="middle"
                icon={<QrcodeOutlined />}
                style={{ 
                  width: '100%',
                  height: 40,
                  background: "#8293f3",
                  border: '2px solid white',
                  color: 'white',
                  fontWeight: 600
                }}
                onClick={() => {
                  Modal.info({
                    title: 'QR Code Zalo',
                    icon: null,
                    width: 400,
                    centered: true,
                    content: (
                      <div style={{ textAlign: 'center', padding: '20px 0' }}>
                        <QRCode 
                          type="svg" 
                          size={250} 
                          value={`https://zalo.me/${infomation.phone}`} 
                          bgColor="#ffffff"
                          style={{ margin: '0 auto' }}
                        />
                        <p style={{ marginTop: 16, color: '#666' }}>
                          Quét mã QR để chat qua Zalo
                        </p>
                      </div>
                    ),
                    okText: 'Đóng'
                  });
                }}
              >
                QR Zalo
              </Button>

              <Button
                icon={<ArrowLeftOutlined />}
                onClick={() => window.history.back()}
                style={{ 
                  width: '100%',
                  height: 40,
                  background: "#bcbdbe",
                  border: '2px solid white',
                  color: 'white',
                  fontWeight: 600
                }}
              >
                Quay lại
              </Button>
            </Space>
          </Card>
        </Col>



        {/* Danh sách chi nhánh và điểm */}
        <Col xs={24}>
          <Card
            title={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>Danh sách chi nhánh và điểm</span>
                {branchLoading && <Spin size="small" />}
              </div>
            }
          >
            {branchLoading ? (
              <div style={{ textAlign: "center", padding: "20px" }}>
                <Spin size="large" />
                <div style={{ marginTop: 16 }}>
                  Đang tải danh sách chi nhánh...
                </div>
              </div>
            ) : branches.length > 0 ? (
              <Collapse
                expandIcon={({ isActive }) => (
                  <CaretRightOutlined rotate={isActive ? 90 : 0} />
                )}
                style={{ background: "#f9f9f9", borderRadius: 8 }}
              >
                {treeBranches.map((parent) => (
                  <Collapse.Panel
                    header={
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <Link 
                          to={`/store-manager?search=${encodeURIComponent(parent.name || "")}`} 
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            color: brand.primary
                          }}
                          className="hover:underline"
                        >
                          <ShopOutlined style={{ color: neutral[400] }} />
                          <strong>{parent.name}</strong>
                        </Link>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                          }}
                        >
                          <Avatar src={resolveImageUrl(parent.rankImageUrl)} size={24} />
                          <strong>{getRank(parent)}</strong>
                          <Text style={{ marginLeft: 8 }}>{(parent.point || 0).toLocaleString("vi-VN")} điểm</Text>
                        </div>
                      </div>
                    }
                    key={parent.id}
                  >
                    {/* Parent branch info */}
                    <Card
                      style={{ marginBottom: 12 }}
                      bodyStyle={{ padding: 12 }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Link 
                          to={`/store-manager?search=${encodeURIComponent(parent.name || "")}`} 
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            color: brand.primary,
                            marginBottom: 8,
                          }}
                          className="hover:underline"
                        >
                          <HomeOutlined style={{ color: neutral[400] }} /> <strong>{parent.name}</strong>
                        </Link>
                        <Text strong>{(parent.point || 0).toLocaleString("vi-VN")} điểm</Text>
                      </div>
                      <p style={{ margin: "4px 0" }}>
                        <strong>Địa chỉ:</strong> {getAddress(parent.address)}
                      </p>
                      {parent.hotline && (
                        <p style={{ margin: "4px 0" }}>
                          <strong>Hotline:</strong> {parent.hotline}
                        </p>
                      )}
                    </Card>

                    {/* Child branches */}
                    {parent.children?.map((child) => (
                      <Card
                        key={child.id}
                        style={{ marginBottom: 12, marginLeft: 20 }}
                        bodyStyle={{ padding: 12 }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Link 
                            to={`/store-manager?search=${encodeURIComponent(child.name || "")}`} 
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                              color: brand.primary,
                              marginBottom: 8,
                            }}
                            className="hover:underline"
                          >
                            <HomeOutlined style={{ color: neutral[400] }} /> <strong>{child.name}</strong>
                          </Link>
                          <Text strong>{(child.point || 0).toLocaleString("vi-VN")} điểm</Text>
                        </div>
                        <p style={{ margin: "4px 0" }}>
                          <strong>Địa chỉ:</strong> {getAddress(child.address)}
                        </p>
                        {child.hotline && (
                          <p style={{ margin: "4px 0" }}>
                            <strong>Hotline:</strong> {child.hotline}
                          </p>
                        )}
                      </Card>
                    ))}
                  </Collapse.Panel>
                ))}
              </Collapse>
            ) : (
              <div style={{ textAlign: "center", padding: "20px" }}>
                <Text type="secondary">Khách hàng chưa có chi nhánh nào</Text>
              </div>
            )}
          </Card>
        </Col>

        <Col xs={24}>
          <PointHistoryCustomer
            data={dataHistories}
            pagination={paginationHistories}
            loading={loadingHistories}
            onChange={handleTableVoiceChange}
          />
        </Col>
      </Row>
    </div>
  );
}
